import * as ReqType from '../types/ServerRequests';
import Axios, { AxiosResponse } from 'axios';
import LoginServices from './LoginServices';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des Medias video et photo
 */
export class MediaService {
    private static instance: MediaService = new MediaService();

    public static getInstance(): MediaService {
        return this.instance;
    }

    /**
     * retourne une liste de media
     * @returns {Promise<Media[]>}
     */
    /*public getMyMediaList(): Promise<ReqType.Media[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_LIST_MEDIA_URL!,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Media[]>) => {
                return response.data;
            }
        );
    }*/

    /**
     * une liste de media
     * @returns {Promise<Media[]>}
     */
    public getAllMediaList(): Promise<ReqType.Media[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_ALL_LIST_MEDIA_URL!,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Media[]>) => {
                return response.data;
            }
        );
    }

    /**
     * permet la supression d'un média
     * @param {Media} media
     * @returns {Promise<void>}
     */
    public supprimerMedia(media: ReqType.Media): Promise<void> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.delete(
            process.env.REACT_APP_MEDIA_DELETE_URL! + '&id=' + media.id,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse) => {
                return;
            }
        );
    }

    public changeAfficher(media: ReqType.Media, bool: boolean): Promise<void> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_MEDIA_VALIDATE_URL! + '&id=' + media.id + '&bool=' + (bool ? 1 : 0),
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse) => {
                return;
            }
        );
    }

    /**
     * permet l'ajout d'un media
     * @param {File} media
     * @param {string} description
     * @param {string} nom
     * @param {number} eventId
     * @returns {Promise<Media>}
     * @constructor
     */
    public AjouterMedia(
        media: File,
        description: string,
        nom: string,
        eventId?: number
    ): Promise<ReqType.Media> {
        const token = LoginServices.getInstance().getUserToken();

        var type: ReqType.Type_Media | undefined = undefined;
        if (media.type.includes('video')) {
            type = ReqType.Type_Media.VIDEO;
        } else if (media.type.includes('image')) {
            type = ReqType.Type_Media.PHOTO;
        }
        if (type !== undefined) {
            var formData = new FormData();
            formData.append('file', media);
            formData.append('description', description);
            formData.append('nom', nom);
            formData.append('type_media_id', type.toString());
            if (eventId !== undefined) {
                formData.append('event_id', eventId.toString());
            }

            return Axios.post(
                process.env.REACT_APP_MEDIA_ADD_URL!,
                formData,
                {
                    headers: { 'X-Access-Token': token },
                }
            ).then(
                (response: AxiosResponse<ReqType.Media>) => {
                    return response.data;
                }
            );
        } else {
            return Promise.reject('');
        }
    }

    /**
     * retourne une liste de media
     * @returns {Promise<Media[]>}
     */
    public getMediaList(): Promise<ReqType.Media[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_MEDIA_VISIBLE_URL!,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Media[]>) => {
                response.data.map(
                    (elem: ReqType.Media) => {
                        elem.type_media_id = Number.parseInt(elem.type_media_id.toString());
                    }
                );
                return response.data;
            }
        );
    }

    /**
     * retourne un media à partir de son id
     * @param {number} id
     * @returns {Promise<Media>}
     */
    public getMedia(id: number): Promise<ReqType.Media> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_MEDIA_VIEW_URL! + '&id=' + id,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Media>) => {
                return response.data;
            }
        );
    }

    /**
     * permet la modifiaction et mise à jour d'un media
     * @param {Media} media
     * @returns {Promise<void>}
     */
    public updateMedia(media: ReqType.Media): Promise<void> {
        const token = LoginServices.getInstance().getUserToken();

        return Axios.put(
            process.env.REACT_APP_MEDIA_EDIT_URL! + '&id=' + media.id,
            media,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            () => {
                return;
            }
        );
    }

    /**
     * retourne un media à partir de l'idmedia et d'un idtag
     * @param {number} mediaId
     * @param {number} tagId
     * @returns {Promise<void>}
     */
    public addTag(mediaId: number, tagId: number): Promise<void> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_MEDIA_ADD_TAG_URL! + '&mediaid=' + mediaId + '&tagid=' + tagId,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            () => {
                return;
            }
        );
    }

    /**
     * supression d'un media à partir d'un idmedia et un idtag
     * @param {number} mediaId
     * @param {number} tagId
     * @returns {Promise<void>}
     */
    public removeTag(mediaId: number, tagId: number): Promise<void> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.delete(
            process.env.REACT_APP_MEDIA_REMOVE_TAG_URL! + '&mediaid=' + mediaId + '&tagid=' + tagId,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            () => {
                return;
            }
        );
    }

    /**
     *
     * @returns {string}
     */
    public getBaseURL() {
        return 'http://preprod-corinitia.890m.com/chorinitia/web/';
    }

    /**
     * retourne des tags
     * @param {number} mediaId
     * @returns {Promise<Tag[]>}
     */
    public getTags(mediaId: number): Promise<ReqType.Tag[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_MEDIA_LIST_TAG_URL! + '&id=' + mediaId,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (r: AxiosResponse<ReqType.Tag[]>) => {
                return r.data;
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/services/MediaService.tsx